import 'css-chunk:src/components/form-fields/fixed-part-text-component/fixed-part-text-component.module.scss';export default {
  "fixed-part-text-component": "fixed-part-text-component_fixed-part-text-component__rkJs2",
  "disabled": "fixed-part-text-component_disabled__-EGC0",
  "input-container": "fixed-part-text-component_input-container__MzTH3",
  "error": "fixed-part-text-component_error__Lc1WY",
  "fixed-part": "fixed-part-text-component_fixed-part__lLprc",
  "grey": "fixed-part-text-component_grey__Ey51o",
  "text": "fixed-part-text-component_text__1CtpW",
  "white": "fixed-part-text-component_white__L6dpH",
  "icon": "fixed-part-text-component_icon__kK5FU",
  "error-text": "fixed-part-text-component_error-text__fBzwp"
};